import { useState, FormEvent } from 'react';

const serviceOptions = [
  'Roof Replacement / New Roof Installation',
  'Roof Repair',
  'Gutter Replacement',
  'Gutter Screens',
  'Skylight Replacement',
  'Solar Installation (Residential)',
  'Solar & Electrical System Evaluations',
  'Battery Systems',
  'Flat Roofing (TPO, PVC)',
  'Metal Roofing',
  'Commercial Solar Installation',
  'Free Inspection',
];

export default function LeadForm() {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [charCount, setCharCount] = useState(0);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const message = (form.elements.namedItem('message') as HTMLTextAreaElement)?.value || '';
    if (message.length > 500) return;

    setLoading(true);
    const data = new URLSearchParams();
    const formData = new FormData(form);
    formData.forEach((value, key) => {
      data.append(key, value.toString());
    });

    try {
      await fetch('https://readdy.ai/api/form/d776npkggtbbtt19refg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data.toString(),
      });
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" className="py-28" style={{ background: '#f8f8f5' }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row gap-16 items-start">

          {/* Left Info */}
          <div className="w-full lg:w-[38%]">
            <span
              className="text-[#d4af37] text-[10px] uppercase tracking-[4px] font-bold block mb-5"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Contact Us
            </span>
            <h2
              className="font-black text-[#0d1a27] leading-tight mb-6"
              style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 'clamp(2rem, 3.5vw, 3rem)', letterSpacing: '-0.02em' }}
            >
              Request Your
              <br />
              Free Estimate
            </h2>
            <p
              className="text-[#777] text-[15px] leading-[1.8] mb-10"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Fill out the form and a member of our team will reach out within 24 hours to schedule your free roof inspection and estimate.
            </p>

            {/* Contact Details */}
            <div className="flex flex-col gap-6">
              <a href="tel:4086280065" className="flex items-center gap-4 group cursor-pointer">
                <div
                  className="w-12 h-12 flex items-center justify-center rounded-full flex-shrink-0"
                  style={{ background: 'rgba(212,175,55,0.1)' }}
                >
                  <i className="ri-phone-line text-[#d4af37] text-xl"></i>
                </div>
                <div>
                  <p className="text-[#aaa] text-[10px] uppercase tracking-[2px] mb-1" style={{ fontFamily: "'Montserrat', sans-serif" }}>Call Us</p>
                  <p className="text-[#0d1a27] font-bold text-lg group-hover:text-[#d4af37] transition-colors" style={{ fontFamily: "'Montserrat', sans-serif" }}>(408) 628-0065</p>
                </div>
              </a>

              <div className="flex items-center gap-4">
                <div
                  className="w-12 h-12 flex items-center justify-center rounded-full flex-shrink-0"
                  style={{ background: 'rgba(212,175,55,0.1)' }}
                >
                  <i className="ri-map-pin-line text-[#d4af37] text-xl"></i>
                </div>
                <div>
                  <p className="text-[#aaa] text-[10px] uppercase tracking-[2px] mb-1" style={{ fontFamily: "'Montserrat', sans-serif" }}>Our Location</p>
                  <p className="text-[#0d1a27] font-semibold text-sm" style={{ fontFamily: "'Montserrat', sans-serif" }}>2959 Winchester Blvd Ste 102a</p>
                  <p className="text-[#888] text-sm" style={{ fontFamily: "'Inter', sans-serif" }}>Campbell, CA 95008</p>
                </div>
              </div>

              <div className="flex items-center gap-4">
                <div
                  className="w-12 h-12 flex items-center justify-center rounded-full flex-shrink-0"
                  style={{ background: 'rgba(212,175,55,0.1)' }}
                >
                  <i className="ri-time-line text-[#d4af37] text-xl"></i>
                </div>
                <div>
                  <p className="text-[#aaa] text-[10px] uppercase tracking-[2px] mb-1" style={{ fontFamily: "'Montserrat', sans-serif" }}>Business Hours</p>
                  <p className="text-[#0d1a27] font-semibold text-sm" style={{ fontFamily: "'Montserrat', sans-serif" }}>Mon – Sat: 7:00 am – 6:00 pm</p>
                  <p className="text-[#888] text-sm" style={{ fontFamily: "'Inter', sans-serif" }}>Sunday: Closed</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Form */}
          <div className="w-full lg:w-[62%]">
            {submitted ? (
              <div className="bg-white rounded-lg p-14 text-center border border-[#eeede8]">
                <div
                  className="w-16 h-16 flex items-center justify-center rounded-full mx-auto mb-6"
                  style={{ background: 'rgba(212,175,55,0.1)' }}
                >
                  <i className="ri-checkbox-circle-line text-[#d4af37] text-4xl"></i>
                </div>
                <h3
                  className="text-2xl font-black text-[#0d1a27] mb-3"
                  style={{ fontFamily: "'Montserrat', sans-serif" }}
                >
                  Request Received!
                </h3>
                <p className="text-[#777] text-base" style={{ fontFamily: "'Inter', sans-serif" }}>
                  Thank you for reaching out. A member of our team will contact you within 24 hours to schedule your free inspection.
                </p>
              </div>
            ) : (
              <form
                data-readdy-form
                id="shadowfax-estimate-form"
                onSubmit={handleSubmit}
                className="bg-white rounded-lg p-8 md:p-10 flex flex-col gap-5 border border-[#eeede8]"
              >
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                  <div className="flex flex-col gap-2">
                    <label
                      className="text-[#333] text-[11px] font-bold uppercase tracking-[2px]"
                      style={{ fontFamily: "'Montserrat', sans-serif" }}
                    >
                      Full Name *
                    </label>
                    <input
                      type="text"
                      name="name"
                      required
                      placeholder="John Smith"
                      className="border-2 border-[#e8e8e4] focus:border-[#d4af37] rounded-md px-4 py-3 text-sm text-[#333] outline-none transition-colors duration-200"
                      style={{ fontFamily: "'Inter', sans-serif", background: '#fafaf8' }}
                    />
                  </div>
                  <div className="flex flex-col gap-2">
                    <label
                      className="text-[#333] text-[11px] font-bold uppercase tracking-[2px]"
                      style={{ fontFamily: "'Montserrat', sans-serif" }}
                    >
                      Phone Number *
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      required
                      placeholder="(408) 000-0000"
                      className="border-2 border-[#e8e8e4] focus:border-[#d4af37] rounded-md px-4 py-3 text-sm text-[#333] outline-none transition-colors duration-200"
                      style={{ fontFamily: "'Inter', sans-serif", background: '#fafaf8' }}
                    />
                  </div>
                </div>

                <div className="flex flex-col gap-2">
                  <label
                    className="text-[#333] text-[11px] font-bold uppercase tracking-[2px]"
                    style={{ fontFamily: "'Montserrat', sans-serif" }}
                  >
                    Email Address *
                  </label>
                  <input
                    type="email"
                    name="email"
                    required
                    placeholder="john@example.com"
                    className="border-2 border-[#e8e8e4] focus:border-[#d4af37] rounded-md px-4 py-3 text-sm text-[#333] outline-none transition-colors duration-200"
                    style={{ fontFamily: "'Inter', sans-serif", background: '#fafaf8' }}
                  />
                </div>

                <div className="flex flex-col gap-2">
                  <label
                    className="text-[#333] text-[11px] font-bold uppercase tracking-[2px]"
                    style={{ fontFamily: "'Montserrat', sans-serif" }}
                  >
                    Service Needed *
                  </label>
                  <select
                    name="service"
                    required
                    className="border-2 border-[#e8e8e4] focus:border-[#d4af37] rounded-md px-4 py-3 text-sm text-[#333] outline-none transition-colors duration-200 cursor-pointer"
                    style={{ fontFamily: "'Inter', sans-serif", background: '#fafaf8' }}
                  >
                    <option value="">Select a service...</option>
                    {serviceOptions.map((opt) => (
                      <option key={opt} value={opt}>{opt}</option>
                    ))}
                  </select>
                </div>

                <div className="flex flex-col gap-2">
                  <label
                    className="text-[#333] text-[11px] font-bold uppercase tracking-[2px] flex justify-between"
                    style={{ fontFamily: "'Montserrat', sans-serif" }}
                  >
                    <span>Message</span>
                    <span className={`text-xs font-normal ${charCount > 450 ? 'text-red-500' : 'text-[#bbb]'}`}>{charCount}/500</span>
                  </label>
                  <textarea
                    name="message"
                    rows={4}
                    maxLength={500}
                    placeholder="Tell us about your roofing needs, property type, or any specific concerns..."
                    onChange={(e) => setCharCount(e.target.value.length)}
                    className="border-2 border-[#e8e8e4] focus:border-[#d4af37] rounded-md px-4 py-3 text-sm text-[#333] outline-none transition-colors duration-200 resize-none"
                    style={{ fontFamily: "'Inter', sans-serif", background: '#fafaf8' }}
                  ></textarea>
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full text-[#1a1a1a] font-bold text-xs py-4 rounded-md transition-all duration-300 cursor-pointer whitespace-nowrap uppercase tracking-[2px] mt-2 disabled:opacity-60"
                  style={{ fontFamily: "'Montserrat', sans-serif", background: loading ? '#c4a030' : '#d4af37' }}
                  onMouseEnter={e => { if (!loading) (e.currentTarget.style.background = '#c4a030'); }}
                  onMouseLeave={e => { if (!loading) (e.currentTarget.style.background = '#d4af37'); }}
                >
                  {loading ? 'Sending...' : 'Request Estimate'}
                </button>

                <p className="text-[#bbb] text-xs text-center" style={{ fontFamily: "'Inter', sans-serif" }}>
                  No spam. No pressure. We&apos;ll reach out within 24 hours.
                </p>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
